// extracted by mini-css-extract-plugin
export default {"cls1":"AgilysysLogo_cls1__-G0De","cls2":"AgilysysLogo_cls2__zhwRQ"};